export class FileExplorerCountWorkspaceEntitiesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "count",
            "baseName": "count",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FileExplorerCountWorkspaceEntitiesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
